import React, { useState } from 'react';
import { useApp } from '../../contexts/AppContext';
import { Book, Section } from '../../types';
import './Sidebar.css';

interface SidebarProps {
  onShowAddBook: () => void;
  onShowAddSection: (bookId: string) => void;
}

export const Sidebar: React.FC<SidebarProps> = ({ onShowAddBook, onShowAddSection }) => {
  const { books, currentSection, selectSection } = useApp();
  const [expandedBooks, setExpandedBooks] = useState<Set<string>>(new Set());

  const toggleBook = (bookId: string) => {
    const newExpanded = new Set(expandedBooks);
    if (newExpanded.has(bookId)) {
      newExpanded.delete(bookId);
    } else {
      newExpanded.add(bookId);
    }
    setExpandedBooks(newExpanded);
  };

  const handleSelectSection = async (section: Section, bookId: string) => {
    await selectSection(section);
    // Ensure the book is expanded when a section is selected
    const newExpanded = new Set(expandedBooks);
    newExpanded.add(bookId);
    setExpandedBooks(newExpanded);
  };

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <h1>Publishing Admin</h1>
        <p>Manage books and content</p>
      </div>
      
      <div className="sidebar-actions">
        <button className="btn btn-primary btn-block" onClick={onShowAddBook}>
          + Add New Book
        </button>
      </div>
      
      <div className="sidebar-content">
        {books.length === 0 ? (
          <div className="empty-state">
            <h3>No Books Yet</h3>
            <p>Click "Add New Book" to get started</p>
          </div>
        ) : (
          <ul className="tree-view">
            {books.map((book) => (
              <li key={book.id} className="tree-book">
                <div 
                  className="tree-book-header" 
                  onClick={() => toggleBook(book.id)}
                >
                  <div className="tree-book-title">
                    <span className={`tree-toggle ${expandedBooks.has(book.id) ? 'expanded' : ''}`}>
                      ▶
                    </span>
                    {book.title}
                  </div>
                </div>
                <ul className={`tree-sections ${expandedBooks.has(book.id) ? 'expanded' : ''}`}>
                  {book.sections.map((section) => (
                    <li
                      key={section.id}
                      className={`tree-section ${currentSection?.id === section.id ? 'active' : ''}`}
                      onClick={() => handleSelectSection(section, book.id)}
                    >
                      {section.section_number && `${section.section_number}. `}
                      {section.title}
                    </li>
                  ))}
                  <li 
                    className="tree-add-section"
                    onClick={() => onShowAddSection(book.id)}
                  >
                    <span>+</span> Add Section
                  </li>
                </ul>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};